// 검색팝업-사람항목
import getNLS from '../_NLS';

import { useState } from 'react';
import { ajaxor4 } from '../../common/basic';

export default props=>{
    if (!props.me) return <></>;
    const [isFollowing, setFollowing] = useState(props.me.followed);

    function toggleFollowThis(){
        ajaxor4({
            url: "/follow/user/"+props.me.id,
            callback: updateState,
        });

        function updateState(d){
            // or unfollowed
            setFollowing((d.status == 'followed'));
        }
    }

    const jsx = (<div className="PersonInfoItem">
        <style jsx>{`

.item{
    height: 54px;
    font-size: 14px;
    color: #343a40;

    padding: 8px 16px;
    text-align: left;
}

.item.highlight{
    background-color: #55d5ce;
    opacity: 0.1;
}

.dib{
    margin: 0 10px;
}

div.line{
    height: initial;
    line-height: initial;
}

.line{
    text-align: left;
}

.l1{
    text-align: left;
}

.l2{
    font-size: 10px;
    color: #868e96;
}

div.right{
    float:right;
    padding-top: 5px;
}

`}</style>

        <div className="item">
            <a href={"/person/Blog?userid="+props.me.id}>
                <div className="dib psa">
                    {/* <img src="/assets/images/ico-empty.svg" /> */}
                    <img className="round-psa" src={
                        !props.me.profile_picture || !props.me.profile_picture[0] || !props.me.profile_picture[0].optimized_url
                        ?"/assets/images/ico-empty.svg":
                        props.me.profile_picture[0].optimized_url
                    } />
                </div>
                <div className="dib">
                    <div className="line l1">{props.me.username}</div>
                    <div className="line l2">{getNLS("팔로워")} {props.me.follower_count} &middot;팔로잉 {props.me.following_count}</div>
                </div>
            </a>
            <div className="right">
                <a onClick={toggleFollowThis}>
                    <img src={
                        "/assets/images/add-user" +
                        (isFollowing ? "" : "_2")
                        + ".svg"
                    } />
                </a>
            </div>
        </div>

    </div>);

    return jsx;
};

